module.exports = __webpack_public_path__ + "static/media/player_joined.c1ed207f.wav";